import React from 'react'
import { Button } from 'antd';
import './styles.scss'

export default ({ on_select_files, on_select_folders, on_upload_files }) => (
  <div className='local-controls'>

    <Button onClick={()=> on_select_files()}>Select Files</Button>
    <Button onClick={()=> on_select_folders()}>Select Folders</Button>
    <div className={'empty'}/>
    <Button type="primary" icon="upload" size={'large'} onClick={()=> on_upload_files()}>Upload Files</Button>

  </div>
)
